import { createObjectIntentType } from '../intent';
import { lazyStyleIntent } from '../style/intents';
import { assignConditionalProperty, mergeConditionalProperty } from '../util';
import { $compiled } from './constants';
import { DEFAULT_KEY, getTokenId, getTokenMode, getTokenPath, isToken, isTokens } from './token';
function assignTokensInternal(input, assignment, overrides, condition, isDefault = false) {
    const isObject = assignment && typeof assignment === 'object';
    if (isToken(input)) {
        if (getTokenMode(input) === 'static') {
            throw new Error(`Cannot assign value to static token "${getTokenPath(input)}"`);
        }
        // Assign in the following cases:
        // - The assignment is not an object
        // - The assignment is a token
        // - The current input is a leaf node (and does not contain nested tokens)
        // - The object was passed to a $default property
        if (!isObject || isToken(assignment) || !isTokens(input) || isDefault) {
            assignConditionalProperty(overrides, getTokenId(input), assignment, condition);
        }
    }
    if (isObject) {
        Object.keys(assignment).forEach((key)=>{
            if (key in input) {
                assignTokensInternal(key === DEFAULT_KEY ? input : input[key], assignment[key], overrides, condition, key === DEFAULT_KEY);
            }
        });
    }
    return overrides;
}
function assignOverrideMap(target, source) {
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        mergeConditionalProperty(target, key, source[key]);
    }
}
export const assignTokensIntent = createObjectIntentType('assignTokens', (decorate)=>(sailOverrides, stylexOverrides)=>{
        if (lazyStyleIntent.isIntent(stylexOverrides)) {
            Object.defineProperty(sailOverrides, $compiled, {
                value: [
                    stylexOverrides
                ],
                enumerable: false,
                writable: false
            });
        }
        return decorate(sailOverrides);
    }, (target, source)=>{
    assignOverrideMap(target, source);
    if (source[$compiled]) {
        target[$compiled] = target[$compiled] || [];
        target[$compiled].push(...source[$compiled]);
    }
});
/**
 * Merges the provided override intents into a single intent.
 */ export function mergeOverrideIntents(overrideIntents) {
    const result = {};
    for(let i = 0; i < overrideIntents.length; i++){
        assignOverrideMap(result, overrideIntents[i]);
    }
    return assignTokensIntent(result);
}
/**
 * Creates an intent to assign a token or tokens to new values when a provided
 * condition is true.
 */ export function assignConditionalTokens(...args) {
    const [condition, input, assignment, // @ts-expect-error - We're not exposing the StyleX token assignment as a public API.
    // This parameter will be added by the Sail X babel plugin during the build process.
    __stylexOverride] = args;
    // Tokens from '@sail/tokens' contain a $instances property that maps token
    // keys to their respective token values.
    const tokens = typeof input === 'object' && input !== null && '$instances' in input ? input.$instances : input;
    return assignTokensIntent(assignTokensInternal(tokens, assignment, {}, condition), __stylexOverride);
}
/**
 * Creates an intent to assign a token or tokens to new values.
 *
 * @see https://sail.stripe.me/apis/assigntokens
 */ export function assignTokens(...args) {
    return assignConditionalTokens('', ...args);
}

//# sourceMappingURL=assignTokens.js.map